import React from "react";
import Navbar from "./header/header";
import Banner from "./banner/banner";
export default function Home() {
    return (
        <>
            <Navbar />
            <Banner />
        </>
    );
}